import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { cn } from '@/lib/utils';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface TextareaFieldProps {
  name: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  readOnly?: boolean;
  className?: string;
  rows?: number;
  maxLength?: number;
}

export const TextareaField = React.forwardRef<HTMLTextAreaElement, TextareaFieldProps>(
  (
    {
      name,
      label,
      placeholder,
      disabled = false,
      required = false,
      readOnly = false,
      className,
      rows = 4,
      maxLength,
    },
    ref
  ) => {
    const { control, formState: { errors } } = useFormContext();
    const error = errors[name];

    return (
      <div className={cn('space-y-2', className)}>
        {label && (
          <Label htmlFor={name}>
            {label}
            {required && <span className="text-destructive ml-1">*</span>}
          </Label>
        )}
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Textarea
              {...field}
              id={name}
              placeholder={placeholder}
              disabled={disabled}
              readOnly={readOnly}
              required={required}
              maxLength={maxLength}
              rows={rows}
              className={cn(error && 'border-destructive', 'resize-none')}
              onChange={(e) => field.onChange(e.target.value)}
            />
          )}
        />
        {error && (
          <p className="text-sm text-destructive">{String(error.message)}</p>
        )}
      </div>
    );
  }
);

TextareaField.displayName = 'TextareaField';

export default TextareaField;
